import { Component, OnInit } from '@angular/core';
import { Boat } from '../l_admin/boat.model';
import { Router } from '@angular/router';
import { BoatService } from '../services/boat.service';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { getBoatImageUrl } from '../utils/image-url.util';

@Component({
  selector: 'app-komodo-national-park',
  templateUrl: './komodo-national-park.component.html',
  styleUrls: ['./komodo-national-park.component.css']
})
export class KomodoNationalParkComponent implements OnInit {
  boats: any[] = [];
  displayedBoats: Boat[] = [];
  filteredBoats: Boat[] = [];
  arrboat: any[] = [];

  displayedImages: any[] = [];
  loading = false;
  error: string | null = null;
  selectedBoat: any | null = null;
  tujuan: string = 'Komodo National Park';

  currentPage = 1;
  itemsPerPage = 6;

  constructor(private apiService: BoatService, private router: Router) {}



  ngOnInit(): void {
    this.displayedImages = [
      'banner_3.webp',
      'Komodo-6-scaled.webp',
      'Komodo-8-scaled.webp',
      'Komodo-2-1024x683.webp',
      'Komodo-5-scaled.webp',
      'Komodo-3-1536x1024.webp',     
    ];
    this.loadBoats();
  }

  loadBoats(): void {
    this.loading = true;
    this.error = null;

    this.apiService
      .getBoatByTujuan(this.tujuan, 'Boat Charter')
      .pipe(
        catchError((error) => {
          this.error = 'Failed to load boats. Please try again later.';
          console.error('Error loading boats:', error);
          return of({ data: [] }); // Mengembalikan array kosong jika terjadi error
        }),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((response) => {
        if (response && response.items) {

          // console.log(response.items);
          // Memfilter data berdasarkan kategori boat
          this.boats = response.items.filter(
            (boat: any) =>
              boat.ms_tujuans &&
              boat.ms_tujuans.some((tujuan: any) =>
                tujuan.tuj.toLowerCase().includes(this.tujuan.toLowerCase())
              )
          );
          this.filteredBoats = [...this.boats];
          this.updateDisplayedBoats();
          this.preloadCarouselImages();
        }
      });
  }

    preloadCarouselImages(): void {
      if (typeof window === 'undefined' || !document) return;

      // Ambil gambar pertama dari setiap boat
      this.filteredBoats.forEach(boat => {
        if (boat.ms_gambarkapals && boat.ms_gambarkapals.length > 0) {
          const firstImage = boat.ms_gambarkapals[0].gambar;
          const url = getBoatImageUrl(firstImage);

          const link = document.createElement('link');
          link.rel = 'preload';
          link.as = 'image';
          link.href = url;
          document.head.appendChild(link);
        }
      });
    }

  getImageUrl(image: any): string {
    const imagePath = image;
    if (imagePath.startsWith('http') || imagePath.startsWith('/assets')) {
      return imagePath;
    }
    return '/assets/img/banner/' + imagePath;
  }

  getBoatImage(image: any): string {
    return getBoatImageUrl(image.gambar);
  }

  loadMore() {
    this.currentPage++;
    this.updateDisplayedBoats();
  }

  private updateDisplayedBoats() {
    const endIndex = this.currentPage * this.itemsPerPage;
    this.displayedBoats = this.filteredBoats.slice(0, endIndex);
  }

  navigateToDetail(slug: string) {
    this.router.navigate(['/detail-boat', slug], {
      queryParams: { destination: 'komodo-national-park' },
    });
  }

}
